<template>
  <div class="today-result">
    <div style="text-align: center;">
      <h3>ງວດປະຈຳວັນທີ່ {{ lottoDate | date }}</h3>
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <h1>
        <EmptyNumbers v-if="status===0" />
        <SpinNumbers v-else-if="status===1" :startShow="startShow" :resultNumbers="resultNumbers" />
        <ShowSuccessResult v-else-if="status===2" :resultNumbers="resultNumbers" />
      </h1>
    </div>
    <div style="text-align: center; margin-top: 10px;">
      <h3>ອອກຜົນລາງວັນ 08:30</h3>
    </div>
    <table>
      <tr>
        <td>ເລກ 5 ໂຕ</td>
        <td>{{ Digit5 }}</td>
      </tr>
      <tr>
        <td>ເລກ 4 ໂຕ</td>
        <td>{{ Digit4 }}</td>
      </tr>
      <tr>
        <td>ເລກ 3 ໂຕ</td>
        <td>{{ Digit3 }}</td>
      </tr>
      <tr>
        <td>ເລກ 2 ໂຕເທິ່ງ</td>
        <td>{{ Digit2Top }}</td>
      </tr>
      <tr>
        <td>ເລກ 2 ໂຕລຸ່ມ</td>
        <td>{{ Digit2Bottom }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

import EmptyNumbers from './EmptyNumbers.vue'
import SpinNumbers from './SpinNumbers.vue'
import ShowSuccessResult from './ShowSuccessResult.vue'

export default {
  name: 'TodayResult',
  components: {
    EmptyNumbers,
    SpinNumbers,
    ShowSuccessResult
  },
  data() {
    return {
      data: null,
      status: 0,
      Interval: null,
      setTimeout: null
    }
  },
  computed: {
    lottoDate() {
      if(this.data) {
        return this.data.lotto_date
      }else{
        return ''
      }
    },
    startShow() {
      if(this.data) {
        return this.data.show_result
      }else{
        return null
      }
    },
    resultNumbers() {
      if(this.results) {
        return this.results.digit5
      }else{
        return null
      }
    },
    results() {
      if(this.data) {
        return this.data.results
      }else{
        return null
      }
    },
    Digit5() {
      if(this.results && this.status === 2) {
        return this.results.digit5
      }else{
        return '-----'
      }
    },
    Digit4() {
      if(this.results && this.status === 2) {
        return this.results.digit4
      }else{
        return '----'
      }
    },
    Digit3() {
      if(this.results && this.status === 2) {
        return this.results.digit3
      }else{
        return '---'
      }
    },
    Digit2Top() {
      if(this.results && this.status === 2) {
        return this.results.digit2_top
      }else{
        return '--'
      }
    },
    Digit2Bottom() {
      if(this.results && this.status === 2) {
        return this.results.digit2_bottom
      }else{
        return '--'
      }
    }
  },
  methods: {
    loadResult() {
      LottoService.nowResult().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
          this.calProcess()
        }
      })
    },
    calProcess() {
      let successTime = moment(this.data.show_result).add(41, 'seconds')
      // ยังไม่ถึงเวลาเริ่มหมุน
      if(moment().isBefore(this.data.start_spin)) {
        this.status = 0
        clearTimeout(this.setTimeout)
        let diff = moment(this.data.start_spin).diff(moment(), 'milliseconds') + 1000
        this.setTimeout = setTimeout(() => {
          this.calProcess()
        }, diff)
      }else
      // อยู่ระหว่างหมุนออกรางวัล
      if(this.data.start_spin && this.data.show_result && moment().isBetween(this.data.start_spin, successTime)) {
        this.status = 1
        clearTimeout(this.setTimeout)
        let diff = moment(this.data.show_result).diff(moment(), 'milliseconds') + 41000
        this.setTimeout = setTimeout(() => {
          this.calProcess()
        }, diff)
      }else
      // กำลังหมุนออกรางวัล แต่ไม่ได้ตั้งเวลาออกผล
      if(moment().isAfter(this.data.start_spin) && !this.data.show_result) {
        this.status = 1
      }else
      // ถึงเวลาออกผลแล้ว
      if(moment().isAfter(this.data.show_result)) {

        let results = this.data.results
        if(results.digit5) {
          // ออกผลเสร็จหมดแล้ว
          if(moment().isAfter(successTime)){
            this.status = 2
          }else{
            // กำลังอยู่ในขั้นตอนแสดงผลที่ล่ะชุดตัวเลข
            let diff = moment(successTime).diff(moment(), 'milliseconds') + 500
            this.setTimeout = setTimeout(() => {
              this.calProcess()
            }, diff)
          }
        // เลยเวลาออกผล แต่ไม่มีผลมา
        } else {
          this.status = 1
          clearTimeout(this.setTimeout)
          this.setTimeout = setTimeout(() => {
            this.loadResult()
          }, 10000)
        }

      }
    }
  },
  created() {
    this.loadResult()
    this.Interval = setInterval(()=>{
      this.loadResult()
    }, 60000)
  },
  filters: {
    date(param) {
      if(param) {
        return moment(param).format("LL")
      }else{
        return '-'
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}

</script>
<style lang="scss" scoped>
.today-result {
  //border: 1px solid #eee;
  min-height: 150px;
  color: #000;
  padding: 20px 30px;
  background-color: #fff;
  /*background: url('../../assets/theme/today-result-bg.png') no-repeat center top;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: 100% 100%;*/
  border: 4px solid darkgoldenrod;

  h1 {
    color: #000;
    font-weight: bold;
    font-size: 60px;
    letter-spacing: 5px;
  }

  h3 {
    color: #000;
  }

  table {
    margin-top: 20px;
    width: 100%;
    max-width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #FFF;

    tr {
      td {
        width: 50%;
        text-align: center;
        border: 1px solid #999;
        padding: 5px;
        font-size: 20px;
      }
    }
  }
}

@media (max-width: 768px) {
  .today-result {
    padding: 10px;
  }
}
</style>
